module.exports = __webpack_public_path__ + "static/img/cont3608.20913a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3608.jpg
// module id = RRpS
// module chunks = 0